const Request = {
  DBInfo: "/Tables/TrafficReport/Info",
  List: "/Tables/TrafficReport/List",
  Info: "/Tables/TrafficReport/Get",
  Add: "/Tables/TrafficReport/Add",
  Delete: "/Tables/TrafficReport/Delete",
  Edit: "/Tables/TrafficReport/Edit",
  Export: "/Tables/TrafficReport/Export",
};

let exports = {
  Request,
};

export default exports;
